import { Navigate } from 'react-router'

const Index = () => {
  return <Navigate to={'/my-team/vendors'} />
}

export default Index
